import Modal from "src/components/Modal";

export default function NewJobDetailLvl1({ isActive,clickHandle }) {
    return (
        <Modal isActive={isActive} clickHandle={clickHandle}>
            <div className="bg-white shadow-md p-10 rounded">
                <form action="">
                    <div className="flex mb-5">
                        <label htmlFor="name" className="w-28 inline-block text-right mr-4 text-gray-500 text-gray-500">نام شغل</label>
                        <input name="name" id="name" type="text" placeholder="نام شغل را در این قسمت وارد کنید" className="border-b-2 border-gray-400 flex-1 py-2 placeholder-gray-300 outline-none focus:border-green-400" />
                    </div>
                    <div className="flex items-center mb-10">
                        <label htmlFor="industries" className="w-28 inline-block text-right mr-4 text-gray-500 text-gray-500">صنعت مربوطه</label>
                        <select type="text" name="industries" id="industries" placeholder="صنعت مربوطه را انتخاب کنید" className="border-b-2 border-gray-400 flex-1 py-2 placeholder-gray-300 outline-none focus:border-green-400" >
                            <option className="">حمل و نقل زمینی</option>
                            <option>حمل و نقل هوایی</option>
                            <option>آموزش</option>
                        </select>
                    </div>
                    <div className="flex items-center mb-10">
                        <label htmlFor="industries" className="w-28 inline-block text-right mr-4 text-gray-500 text-gray-500">تعریف شغل</label>
                        <textarea rows="1" placeholder="شغل مدنظر را در چند جمله تعریف کنید" className="border-b-2 border-gray-400 flex-1 py-2 placeholder-gray-300 outline-none focus:border-green-400">
                        </textarea>
                    </div>
                    <div className="flex items-center mb-10">
                        <label htmlFor="industries" className="w-28 inline-block text-right mr-4 text-gray-500 text-gray-500">شرح وظایف شغل</label>
                        <textarea rows="1" placeholder="وظایف شغل مدنظر را در چند جمله تعریف کنید" className="border-b-2 border-gray-400 flex-1 py-2 placeholder-gray-300 outline-none focus:border-green-400">
                        </textarea>
                    </div>
                    <div className="text-left">
                        <button className="py-3 px-8 bg-green-500 text-green-100 font-bold rounded">مرحله بعدی</button>
                    </div>
                </form>
            </div>
        </Modal>
    )
}